import { FileType } from "./file-type.enum";

    /**
     * @description
     *  Modelo de un archivo de usuario.
     *
     * @see gigot-backend/ViewModels/ApplicationUser/UserFileDto.cs
     */

export class UserFile {

    public fileName: string;
    public fileType: FileType;
    public id: number;
    public url: string;
    public validated: boolean;

    /**
     * @description
     *  Construye un archivo con una semántica vacía. Nótese que no es lo
     *  mismo que construir un archivo con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un archivo vacío.
     */
    public static empty(): UserFile {
        const userFile: UserFile = new UserFile();
        userFile.fileName = "";
        userFile.fileType = undefined;
        userFile.id = undefined;
        userFile.url = "";
        userFile.validated = false;
        return userFile;
    }

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicUserFile
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicUserFile: UserFile): UserFile {
		if (!anemicUserFile) return undefined;
		const userFile: UserFile = UserFile.empty();
		userFile.fileName = anemicUserFile.fileName;
        userFile.fileType = anemicUserFile.fileType;
        userFile.id = anemicUserFile.id;
        userFile.url = anemicUserFile.url;
        userFile.validated = anemicUserFile.validated;
		return userFile;
	}
}
